/**
 * @generated SignedSource<<4192791adef32f7e84ecc39306e3e5d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authOnly"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerAccountId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pOrder"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showCanceled"
},
v9 = [
  {
    "kind": "Variable",
    "name": "appName",
    "variableName": "appName"
  },
  {
    "kind": "Variable",
    "name": "authOnly",
    "variableName": "authOnly"
  },
  {
    "kind": "Variable",
    "name": "customerAccountId",
    "variableName": "customerAccountId"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "orderby",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "paymentOrder",
    "variableName": "pOrder"
  },
  {
    "kind": "Variable",
    "name": "showCanceled",
    "variableName": "showCanceled"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CustomerSubscriptionChargesConnection",
        "kind": "LinkedField",
        "name": "getcustomersubscriptioncharges4",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SubscriptionsList_sl"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubscriptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CustomerSubscriptionChargesConnection",
        "kind": "LinkedField",
        "name": "getcustomersubscriptioncharges4",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerSubscriptionCharge",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttlTmBcSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttlLmBcSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttlYtdBcSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttlTmMkSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttlLmMkSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ttlYtdMkSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pAccountName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appSku",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appLogo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appSkuPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appMarkupPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appMarkupAbsolute",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "soEntered",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initiatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAppId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAppStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerListSubscription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerViewSubscription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bcStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cappPaymentOrder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cappSkuPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cappMarkupPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cappMarkupAbsolute",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tmBcSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lmBcSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ytdBcSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tmMkSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lmMkSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ytdMkSum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ccLast4",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ccExpy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rPaymentOrder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rAppMarkupPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rPassThroughFees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flowTaskId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskData",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flowStepId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stepState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flowId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fdbd45e393e06b80f78c87e03b13e230",
    "id": null,
    "metadata": {},
    "name": "SubscriptionsQuery",
    "operationKind": "query",
    "text": "query SubscriptionsQuery(\n  $customerAccountId: UUID\n  $appName: String\n  $pOrder: Int\n  $authOnly: Int\n  $showCanceled: Int\n  $orderBy: Int\n  $direction: Int\n  $first: Int\n  $offset: Int\n) {\n  getcustomersubscriptioncharges4(customerAccountId: $customerAccountId, appName: $appName, paymentOrder: $pOrder, authOnly: $authOnly, showCanceled: $showCanceled, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {\n    totalCount\n    ...SubscriptionsList_sl\n  }\n}\n\nfragment SubscriptionsList_sl on CustomerSubscriptionChargesConnection {\n  nodes {\n    ttlTmBcSum\n    ttlLmBcSum\n    ttlYtdBcSum\n    ttlTmMkSum\n    ttlLmMkSum\n    ttlYtdMkSum\n    pAccountId\n    pAccountName\n    appId\n    appName\n    appSku\n    appLogo\n    appUrl\n    appSkuPrice\n    appMarkupPercentage\n    appMarkupAbsolute\n    soEntered\n    initiatedBy\n    customerAppId\n    customerAppStatus\n    customerListSubscription\n    customerViewSubscription\n    bcStatus\n    cappPaymentOrder\n    cappSkuPrice\n    cappMarkupPercentage\n    cappMarkupAbsolute\n    tmBcSum\n    lmBcSum\n    ytdBcSum\n    tmMkSum\n    lmMkSum\n    ytdMkSum\n    created\n    updated\n    ccLast4\n    ccExpy\n    rPaymentOrder\n    rAppMarkupPercentage\n    rPassThroughFees\n    flowTaskId\n    taskType\n    taskData\n    flowStepId\n    stepState\n    flowId\n  }\n}\n"
  }
};
})();

node.hash = "a3bf838a6fff6cc5802b00a4a3c4232d";

module.exports = node;
